module.exports = __webpack_public_path__ + "img/printing.ea1307ac.svg";